const routes = {
  root: '/assessment-platform',
}

export default routes
